/**============================================================
*   [component] ToggleOverlayAccordion
*   description : グラデマスクアコーディオン
============================================================*/
<template>
  <div class="p-nav-toggle-overlay">
    <transition
        name="vue-toggle"
        @before-enter="beforeEnter"
        @enter="enter"
        @before-leave="beforeLeave"
        @leave="leave"
      >
      <div
        class="p-nav-toggle-overlay__body"
        ref="body"
        v-bind:class="{'is-lines-more-2':state.isMask, 'is-toggle-opened': String(state.openNum).includes(1) || String(state.openNum).includes('all')}"
        v-show="String(state.openNum).includes(1) || String(state.openNum).includes('all')"
        v-cloak
      >
        <slot name="body"></slot>
      </div>
    </transition>
    <button
      class="p-nav-toggle-overlay__button"
      v-bind:class="{'is-toggle-opened': String(state.openNum).includes(1) || String(state.openNum).includes('all')}"
      @click="toggleTarget(1)"
    >
      <i class="c-icon">
        <svg class="svg-icon_arrow-dims">
          <use xlink:href="/cms/wp-content/themes/ce-corp/assets/img/shared/sprite.symbol.svg#icon_arrow"></use>
        </svg>
      </i>
    </button>
  </div>
</template>
<script>
import {getCurrentInstance, onMounted, reactive, watchEffect} from 'vue';
import { createMedia } from 'vue-use-media';
export default {
  props: ['name'],
  name: 'ToggleOverlayAccordion',
  setup() {
    const currentComponent = getCurrentInstance();
    const media = createMedia({
      isDesktop: 'screen and (min-width: 960px)'
    })
    const state = reactive({
      openNum: [],
      defaultHeight: '0',
      maxHeight: 96,
      isMask: false
    })

    const resetCategory = function() {
      state.defaultHeight
      state.openNum = [];
      if(media.isDesktop){
        //PC時のデフォルト状態
        state.openNum = ["all"];
      }else{
        //SP時のデフォルト状態
        state.openNum = [];

      }
    }

    onMounted(() => {
      //初期化
      watchEffect(() => {
        resetCategory();
      })
      //mask
      setMask();
      window.addEventListener('resize', setMask, 200);

    })
    const setMask = () => {
      let target = currentComponent.refs.body;
      const height = target.clientHeight;

      if(height > state.maxHeight) {
        if (window.matchMedia('(min-width: 960px)').matches) {
          state.isMask = false;
        }else{
          state.isMask = true;
        }
      }
    }
    //子階層の開閉
    //指定のカテゴリ名を受け取って表示：初期値は0（非表示）
    const toggleTarget = (num)=> {
      state.isStopAnimation = false;
      if(String(state.openNum).includes(num)){
        let result = state.openNum;
        result = result.filter((item) => {
          return (item != num);
        });
        state.openNum = result;
      }else{
        state.openNum.push(num);
      }
    }

    const beforeEnter = (el)=> {
      el.style.height = ''
    }
    const enter = (el)=> {
      el.style.height = el.scrollHeight + 'px'
    }
    const beforeLeave = (el)=> {
      el.style.height = el.scrollHeight + 'px'
    }
    const leave = (el)=> {
      el.style.height = ''
    }

    return {
      media,
      state,
      toggleTarget,
      resetCategory,
      beforeEnter,
      enter,
      beforeLeave,
      leave
    }
  },
}
</script>

